import { serialize as domFormSerializer } from "dom-form-serializer";

export const reclaimFormVueConfig = {
    el: '#reclaim-form-app',
    data() {
        return {
            errors: [],
            completed:       false,
            showForm:        true,
            showGlobalError: false,
            showSuccess:     false
        }
    },
    methods: {
        clearErrors() {
            if (this.errors.length === 0) {
                return;
            }

            this.errors = [];
            document.querySelectorAll('.is-invalid').forEach(elem => {
                elem.classList.remove('is-invalid');
            });
            document.querySelectorAll('.invalid-feedback').forEach(elem => {
                elem.classList.remove('d-block');
            });
        },
        showErrors() {
            Object.entries(this.errors).forEach(error => {
                let fieldName = error[0];
                let message = error[1][0];
                let elem = document.querySelector('#' + fieldName).nextElementSibling;
                elem.innerHTML = message;
                elem.classList.add('d-block');
            });
        },
        showReclaimError(message) {
            console.log(message);
            document.querySelector('.globalError').innerHTML = message;
            this.showSuccess = false;
            this.showForm = false;
            this.showGlobalError = true;
        },
        showCompleted() {
            this.showSuccess = true;
            this.showForm = false;
            this.showGlobalError = false;
        },
        submitForm() {
            this.clearErrors();
            axios
                .post(document.querySelector('form').action, domFormSerializer(document.querySelector('form')))
                .then(response => {
                    if (response.data.globalError === true) {
                        this.globalError = true;
                        this.showReclaimError(response.data.message)
                    } else {
                        this.completed = true;
                    }
                })
                .catch(error => {
                    let errorResponseData = error.response.data;
                    this.errors = errorResponseData.errors;
                })
        }
    },
    watch: {
        errors: function() {
            this.showErrors();
        },
        completed: function() {
            this.showCompleted();
        }
    },
};
